const accountObject = {
    configName: 'account',
    container: null,
    animationContainer: null,
    parallaxSlide1Container: null,
    endBefore: null,
    endSlide1: null,
    endSlide2: null,
    heightContainer: null,
    status: -1,
    isHideAllCanvas: false,
    initAnimationRotate: false,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;
        this.container = document.querySelector('.account__container');

        this.animationContainer = this.container.querySelector('.account-animation__container');
        this.parallaxSlide1Container = this.container.querySelector('.account__parallax-slide1');

        this.reactToResize();
        main.setLoaderPercent(1);
    },
    initializeAnimationRotate: function () {
        if (window.innerWidth < main.mobileResolutionBorder) return;
        if (this.initAnimationRotate) return;

        this.initAnimationRotate = true;
        const phoneAnimation = [];

        for (let i = 1; i <= 60; i++) {
            phoneAnimation.push(`${document.location.origin}/i/instaforex/images/phone/${i.toString().padStart(4, '0')}.jpg`);
        }

        animationPlayerObject.register({
            'canvas': document.getElementById('account-animation__canvas'),
            'arrayImage': phoneAnimation,
            'initFrame': 1,
            'name': 'phone',
            'duration': 600
        });

        animationPlayerObject.subscribeOnEvent('phone', this.reactToAnimation, this);

        const buttons = this.container.querySelectorAll('.account__button');

        for (const button of buttons) {
            button.addEventListener('mouseover', this.reactToHover.bind(this));
            button.addEventListener('touchstart', this.reactToHover.bind(this), {passive: true});
        }
        main.setLoaderPercent(1);
    },
    setCheckpoints: function () {
        const config = main.detectScroll.getConfig(this.configName);

        this.endBefore = config.height * .21;
        this.endSlide1 = this.endBefore + config.height * .5;
        //this.endSlide2 = this.endSlide1 + config.height * .18;
        this.endSlide2 = config.height - footerObject.heightFooter;
    },
    easeFunction: new CubicBezier(.43, .31, .65, .99),
    easeFunctionEnd: new CubicBezier(.29, .37, .62, .85),
    statusScroll: null,
    mobileScroll: function (data) {
        if (data.isVisible) {
            if (this.statusScroll !== 1) {
                this.statusScroll = 1;
                riveAccountObject.startRendering(1);
                riveAccountObject.play(1);
            }
        } else {
            if (this.statusScroll !== 2) {
                this.statusScroll = 2;
                riveAccountObject.reset(1);
                riveAccountObject.stopRendering(1);
            }
        }
    },
    scroll: function (data) {
        if (data.localOffset <= this.endBefore) {
            if (this.statusScroll !== 'begin') {
                this.statusScroll = 'begin';
                riveAccountObject.startRendering(1);
                riveAccountObject.play(1);
            }
            const x = data.localOffset / this.endBefore;
            let scrollCalc = 100 * this.easeFunction(x);
            if (scrollCalc > 100) scrollCalc = 100;

            this.container.style.transform = 'translate3d(0, -' + scrollCalc + '%, 0)';
            this.container.classList.remove('_slide_2');
            if (data.localOffset > this.endBefore * .7/* && data.direction > 0*/) {
                this.container.classList.add('_slide_1');
            } else {
                this.container.classList.remove('_slide_1');
            }
        }

        if (
            data.localOffset > this.endBefore &&
            data.localOffset <= this.endSlide1 &&
            this.statusScroll !== 'slide1'
        ) {
            if (this.statusScroll === 'slide2') animationPlayerObject.play('phone', 'backward');
            this.statusScroll = 'slide1';
            this.container.classList.add('_slide_1');
            this.container.classList.remove('_slide_2');
            this.container.style.transform = 'translate3d(0, -100%, 0)';
        }

        if (data.localOffset <= this.endSlide1) {
            this.setParallaxOffset(data.localOffset / this.endSlide1);
        }

        if (
            data.localOffset > this.endSlide1 &&
            data.localOffset <= this.endSlide2 &&
            this.statusScroll !== 'slide2'
        ) {
            if (this.statusScroll === 'slide1') animationPlayerObject.play('phone', 'forward');
            this.statusScroll = 'slide2';
            this.container.classList.add('_slide_2');
            //this.container.classList.remove('_slide_1');
            this.container.classList.add('_first-time');
        }

        if (data.localOffset > this.endSlide2) {
            if (this.statusScroll !== 'end') {
                this.statusScroll = 'end';
            }
        }

        if (data.localOffset > this.endSlide1) {
            const scroll = data.localOffset - this.endSlide2;
            const height = data.end - data.start - this.endSlide2;
            let x = scroll / height;
            const calcScroll = this.calcOffsetFromFooter() * this.easeFunctionEnd(x);
            this.container.style.transform = 'translate3d(0,' + -(this.heightContainer + calcScroll) + 'px , 0)';
        }
    },
    reactToScroll: function (data) {
        if (data.isVisible) {
            if (window.innerWidth < main.mobileResolutionBorder) {
                this.mobileScroll(data);
            } else {
                this.scroll(data);
            }
        } else {
            if (!this.isHideAllCanvas) {
                this.isHideAllCanvas = true;
                riveAccountObject.reset(1);
                riveAccountObject.stopRendering(1);
                if (riveAccountObject.initSecondRive) riveAccountObject.stopRendering(2);
                this.statusScroll = null;
            }
        }
    },
    checkStatusLoad: function () {
        let isAllLoad = true;
        Object.keys(this.frames).forEach((id) => {
            if (this.frames[id] === null) isAllLoad = false;
        });

        if (isAllLoad) {
            this.canvas.width = this.frames[1].width;
            this.canvas.height = this.frames[1].height;
            this.status = 1;
        }

    },
    reactToAnimation: function (eventTime, animationName, animationDirection) {
        if (eventTime === 'before' && animationDirection === 'forward') {
            riveAccountObject.pause(1);
            riveAccountObject.stopRendering(1);
        }

        if (eventTime === 'after' && animationDirection === 'forward') {
            riveAccountObject.startRendering(2);
            riveAccountObject.play(2);
        }

        if (eventTime === 'before' && animationDirection === 'backward') {
            riveAccountObject.stopRendering(2);
        }

        if (eventTime === 'after' && animationDirection === 'backward') {
            riveAccountObject.startRendering(1);
            riveAccountObject.reset(1);
            riveAccountObject.play(1);
        }
    },
    calcOffsetFromFooter: function () {
        return (footerObject.heightFooter + 90) - this.offsetFromFooter;
    },
    reactToResize: function () {
        this.container.parentElement.classList.add('_show');
        this.heightContainer = this.container.getBoundingClientRect().height;
        const heightAnimationElement = this.animationContainer.getBoundingClientRect().height;
        this.container.parentElement.classList.remove('_show');
        this.offsetFromFooter = (this.heightContainer - heightAnimationElement) / 2;
        this.container.style.transform = '';
        this.parallaxSlide1Container.style.transform = '';
        this.setCheckpoints();
        this.initializeAnimationRotate();
    },
    reactToHover: function (e) {
        const event = e || window.event;
        let target = event.target;
        while (target !== null) {
            if (target.classList.contains('account__button')) break;

            target = target.parentElement;
        }

        if (target === null) return;

        const type = target.dataset.type;

        if (this.currentType !== type) {
            this.currentType = type;
            riveAccountObject.instances['canvas-2'].stateMachineInputs('state')[type].fire()
        }
    },
    setParallaxOffset: function (x) {
        if (x < 0) x = 0;
        if (x > 1) x = 1;
        this.parallaxSlide1Container.style.transform = 'translate3d(0, ' + (15 - 15 * x) + '%, 0)';
    }
};
